import { STATUS_TYPE } from '../../../enum';


export interface TotalOrder {
  count: number;
  date: string;
}

export interface TotalSales {
  sale: number;
  date: string;
}

export interface FindDashboardReport {
  // timePeriod: string;
}

export interface DashboardReport {
  adminUsersCount: number;
  agentUsersCount: number;
  individualUsersCount: number;
  companyUsersCount: number;
  notApprovedCompanyUserCount: number;
  brokerUsersCount: number;
  notApprovedBrokerUserCount: number;
  publishedAdvertiseCount: number;
  submitAdvertiseCount: number;
  pendingContactUsRequestCount: number;
}

export interface InitialState {
  data: DashboardReport | null;
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: null,
  skip: 0,
  limit: 5,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};